import React, { useState, createContext } from "react"
import PropTypes from "prop-types"
import Layout from "../layout"
import SEO from "../seo"
import Banner from "../banner"
import Container from "../container"
import ContentHeader from "../content-header"
import CardContainer from "../card-container"
import ContentSearch from "../content-search"
import Wrapper from "../wrapper"
import faq from "../../assets/pageData/faq"
import WidePattern from "../wide-pattern"
import styles from "./faqLayout.module.scss"
const title = `<span className='underlined'><span>Frequently</span></span> Asked<br>  <span className='underlined'><span>Questions</span></span>`

const questions = faq.reduce((acc, item) => {
  const itemResources = item.resources.map(resource => ({
    ...resource,
    slug: `/${item.id}/${resource.id}`,
  }))
  return acc.concat(itemResources)
}, [])

const FaqContext = createContext()

const { Provider } = FaqContext

const FaqLayout = ({ className, children, location }) => {
  const [term, setTerm] = useState("")
  const [result, setResult] = useState([])
  const [showResult, setShowResult] = useState(false)
  const handleChange = ({ target: { value } }) => {
    if (!showResult) setShowResult(true)
    setTerm(value)
    handleSearch(value)
  }

  const handleSearch = value => {
    const searchTerm = value
      .toLowerCase()
      .split(" ")
      .filter(item => item !== "")
    const searchResult = searchTerm.reduce((acc, term) => {
      const result = questions.filter(
        ({ name, description }) =>
          name.toLowerCase().includes(term) ||
          description.toLowerCase().includes(term)
      )
      return acc.concat(result)
    }, [])
    setResult([...new Set(searchResult)])
  }

  return (
    <Provider value={{ showResult, setShowResult }}>
      <Layout
        showNav
        location={location}
        onClick={() => (showResult ? setShowResult(false) : null)}
        className={styles.faqLayout}
      >
        <SEO title="FAQ" slug="faq" />
        <Container>
          <Wrapper>
            <ContentHeader title={title} backText="Questions">
              <ContentSearch
                value={term}
                handleChange={handleChange}
                placeholder={`Search a keyword e.g “POS Issue”`}
                result={result}
              />
            </ContentHeader>
          </Wrapper>

          <div className="contentHolder">
            <CardContainer>
              <div className={className}>{children}</div>
            </CardContainer>
          </div>
        </Container>
        <WidePattern type="dark" />
        <Banner type="list" />
      </Layout>
    </Provider>
  )
}
ContentSearch.propTypes = {
  className: PropTypes.node,
  location: PropTypes.object,
}
ContentSearch.defaultProps = {
  className: "",
  location: {},
}

FaqLayout.context = FaqContext

export default FaqLayout
